import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=83753818&scoped=true&"
import script from "./ButtonAction.vue?vue&type=script&lang=js&"
export * from "./ButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=83753818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83753818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83753818')) {
      api.createRecord('83753818', component.options)
    } else {
      api.reload('83753818', component.options)
    }
    module.hot.accept("./ButtonAction.vue?vue&type=template&id=83753818&scoped=true&", function () {
      api.rerender('83753818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/ButtonAction.vue"
export default component.exports